"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutLoginContainerNewAuth = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const common_components_1 = require("@as-react/common-components");
const andes_react_1 = require("@yonderland/andes-react");
const common_types_1 = require("@as-react/common-types");
const react_1 = require("react");
const react_router_1 = require("react-router");
const react_redux_1 = require("react-redux");
const BasketActions_creators_1 = require("../../redux/basket/actions/BasketActions.creators");
const AuthActions_creators_1 = require("../../redux/authentication/actions/AuthActions.creators");
const AnalyticsActions_creators_1 = require("../../redux/analytics/actions/AnalyticsActions.creators");
const CheckoutActions_creators_1 = tslib_1.__importDefault(require("../../redux/checkout/actions/CheckoutActions.creators"));
const SessionSelector_1 = require("../../redux/session/selectors/SessionSelector");
const URLParamUtil_1 = require("../../util/URLParamUtil");
const ShoplandingLogin_1 = require("../../components/checkout/login/shoplanding/ShoplandingLogin");
const useGuestLogin_1 = require("../../hooks/useGuestLogin");
const common_utils_1 = require("@as-react/common-utils");
const useOAuth_1 = require("../../hooks/useOAuth");
const react_i18next_1 = require("react-i18next");
const i18nConstants_1 = require("../../constants/i18nConstants");
const CheckoutLoginContainer_1 = require("./CheckoutLoginContainer");
const CheckoutLoginContainerNewAuth = () => {
    const { isShopLanding, root, isInAuthorMode } = (0, common_components_1.useAemConfig)();
    const history = (0, react_router_1.useHistory)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)([i18nConstants_1.I18N_NAMESPACES.account, i18nConstants_1.I18N_NAMESPACES.general]);
    const { guestLogin, errorMessage: guestErrorMessage, isPending: isGuestLoginPending } = (0, useGuestLogin_1.useGuestLogin)();
    const { authUrl, loggedIn: oauthLoggedIn } = (0, useOAuth_1.useOAuth)({ returnTo: `${root}buy.html`, flow: 'checkout' });
    const guestError = t(guestErrorMessage || '');
    const loggedIn = (0, react_redux_1.useSelector)((0, SessionSelector_1.makeGetLoggedInState)()) || oauthLoggedIn;
    (0, react_1.useEffect)(() => {
        dispatch(BasketActions_creators_1.basketActions.createGetAction());
        dispatch(AuthActions_creators_1.authActions.createInitSocialAction());
        dispatch(AnalyticsActions_creators_1.analyticsActions.checkoutStep({ step: 2 }));
        dispatch(CheckoutActions_creators_1.default.createLoginAnalyticsAction());
        dispatch(CheckoutActions_creators_1.default.createSetHasRegistrationAction(false));
    }, []);
    (0, react_1.useEffect)(() => {
        if (loggedIn) {
            history.replace((0, URLParamUtil_1.generatePathUrl)(root, `buy.html/${common_types_1.RoutePathname.DELIVERY}`, isInAuthorMode));
            return;
        }
        const guestCookie = common_utils_1.CookieUtil.get('guest');
        if (guestCookie) {
            guestLogin(guestCookie);
        }
        else {
            window.location.href = authUrl;
        }
    }, [loggedIn]);
    if (isShopLanding) {
        return ((0, jsx_runtime_1.jsx)(CheckoutLoginContainer_1.LoginLayout, { children: (0, jsx_runtime_1.jsx)(ShoplandingLogin_1.ShoplandingLogin, {}) }));
    }
    return ((0, jsx_runtime_1.jsxs)(andes_react_1.Box, { padding: '4', children: [guestError && (0, jsx_runtime_1.jsx)(andes_react_1.Banner, { text: guestError, status: "error" }), isGuestLoginPending && (0, jsx_runtime_1.jsx)(andes_react_1.Spinner, { fitContainer: true })] }));
};
exports.CheckoutLoginContainerNewAuth = CheckoutLoginContainerNewAuth;
